import { collection, addDoc } from "firebase/firestore";
import { FC, useState } from "react";
import { db } from "../../firebase";
import { Box, Button, TextField } from "@mui/material";

interface GroceryFormProps {
  handleToggleForm: () => void;
}

export const GroceryForm: FC<GroceryFormProps> = ({ handleToggleForm }) => {
  const [name, setName] = useState("");
  const [quantity, setQuantity] = useState(1);
  const [notes, setNotes] = useState("");
  const [iconLabel, setIconLabel] = useState("");
  const [imageUrl, setImageUrl] = useState("");

  const handleNameChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setName(event.target.value);
  };

  const handleQuantityChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setQuantity(Number(event.target.value));
  };

  const handleNotesChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setNotes(event.target.value);
  };

  const handleIconLabelChange = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    setIconLabel(event.target.value);
  };

  const handleImageUrlChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setImageUrl(event.target.value);
  };

  const handleSubmit = async (event: React.FormEvent) => {
    event.preventDefault();
    if (!name && !quantity) {
      return;
    }
    // Add a new grocery to the groceries collection
    const groceryCollection = collection(db, "groceries");
    await addDoc(groceryCollection, {
      name,
      quantity,
      notes,
      iconLabel,
      imageUrl,
    });

    // Reset the form fields
    setName("");
    setQuantity(1);
    setNotes("");
    setIconLabel("");
    setImageUrl("");
  };

  return (
    <form onSubmit={handleSubmit}>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          marginY: 5,
          py: 10,
          justifyContent: "space-around",
          alignItems: "center",
          backgroundColor: "#f0f0f0",
          gap: 4,
        }}
      >
        <TextField
          type="text"
          value={name}
          onChange={handleNameChange}
          label="Name"
        />
        <TextField
          type="number"
          value={quantity}
          onChange={handleQuantityChange}
          label="Quantity"
        />
        <TextField
          type="text"
          value={notes}
          onChange={handleNotesChange}
          label="Notes"
        />
        <TextField
          type="text"
          value={iconLabel}
          onChange={handleIconLabelChange}
          label="Icon Label"
        />
        <TextField
          type="text"
          value={imageUrl}
          onChange={handleImageUrlChange}
          label="Image URL"
        />
        <Button type="submit" variant="contained" color="primary">
          Add Grocery
        </Button>
        <Button onClick={handleToggleForm} variant="contained" color="warning">
          Cancel
        </Button>
      </Box>
    </form>
  );
};
